let sdkPromise: Promise<NonNullable<Window['FB']>> | null = null;

export function loadMetaFacebookSdk(appId: string, graphApiVersion: string): Promise<NonNullable<Window['FB']>> {
  if (sdkPromise) return sdkPromise;
  if (window.FB) {
    try {
      window.FB.init({ appId, cookie: true, xfbml: false, version: graphApiVersion });
      return Promise.resolve(window.FB);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  let resolveSdk!: (sdk: NonNullable<Window['FB']>) => void;
  let rejectSdk!: (error: unknown) => void;
  const promise = new Promise<NonNullable<Window['FB']>>((resolve, reject) => {
    resolveSdk = resolve;
    rejectSdk = reject;
  });
  sdkPromise = promise;

  const previousInit = window.fbAsyncInit;
  let settled = false;
  let timeout: number | undefined;
  let script: HTMLElement | null = null;

  const cleanup = (failed: boolean) => {
    if (timeout !== undefined) window.clearTimeout(timeout);
    script?.removeEventListener('error', onError);
    if (window.fbAsyncInit === initialize) window.fbAsyncInit = previousInit;
    // A failed script must be replaced so a new attempt can actually load it.
    if (failed) script?.remove();
    if (sdkPromise === promise) sdkPromise = null;
  };
  const fail = (error: unknown) => {
    if (settled) return;
    settled = true;
    cleanup(true);
    rejectSdk(error);
  };
  const onError = () => fail(new Error('Não foi possível carregar o SDK da Meta'));
  const initialize = () => {
    if (settled) return;
    try {
      if (!window.FB) throw new Error('SDK da Meta indisponível');
      window.FB.init({ appId, cookie: true, xfbml: false, version: graphApiVersion });
      settled = true;
      cleanup(false);
      resolveSdk(window.FB);
    } catch (error) {
      fail(error);
    }
  };

  try {
    const existing = document.getElementById('facebook-jssdk');
    script = existing || document.createElement('script');
    script.addEventListener('error', onError);
    window.fbAsyncInit = initialize;
    timeout = window.setTimeout(() => fail(new Error('Tempo limite ao carregar o SDK da Meta')), 15000);
    if (!existing) {
      const sdkScript = script as HTMLScriptElement;
      sdkScript.id = 'facebook-jssdk';
      sdkScript.async = true;
      sdkScript.defer = true;
      sdkScript.crossOrigin = 'anonymous';
      sdkScript.src = 'https://connect.facebook.net/pt_BR/sdk.js';
      document.head.appendChild(sdkScript);
    }
  } catch (error) {
    fail(error);
  }
  return promise;
}

export function isAllowedMetaMessageOrigin(origin: string): boolean {
  return new Set([
    'https://www.facebook.com',
    'https://web.facebook.com',
    'https://business.facebook.com',
  ]).has(origin);
}
